import React, { type ComponentType } from 'react';
import type { ActivitySortOrderType } from '@atlassian/jira-issue-shared-types';
import FeedSkeleton from '@atlassian/jira-issue-view-activity-common/src/component/feed-skeleton';
import { FeedContainer } from '@atlassian/jira-issue-view-activity-common/src/styles';
import type { IssueKey, BaseUrl } from '@atlassian/jira-shared-types';
import IssueHistoryServiceDI from '../services/issue-history';
import HistoryItemsView from './history-items';

type Props = {
	issueKey: IssueKey;
	baseUrl: BaseUrl;
	sortOrder: ActivitySortOrderType;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	GroupedActivityEntryComponent?: ComponentType<Record<any, any>>;
};

const HistoryItemsDI = HistoryItemsView;

type InternalProps = Props & {
	HistoryItems: typeof HistoryItemsDI;
	IssueHistoryService: typeof IssueHistoryServiceDI;
};

const IssueHistory = ({
	baseUrl,
	issueKey,
	sortOrder,
	HistoryItems,
	IssueHistoryService,
	GroupedActivityEntryComponent,
}: InternalProps) => (
	<FeedContainer data-testid="issue-history.ui.feed-container">
		<IssueHistoryService baseUrl={baseUrl} issueKey={issueKey} sortOrder={sortOrder}>
			{/* @ts-expect-error - TS2322 - Type '({ loading, loadingMore, hasMore, loadMore, error, data }: ServiceResult) => Element | null' is not assignable to type '(arg1: ServiceResult) => ReactElement<any, string | JSXElementConstructor<any>>'. */}
			{({ loading, loadingMore, hasMore, loadMore, error, data }) => {
				if (loading) {
					return <FeedSkeleton />;
				}
				if (error) {
					return null;
				}

				return (
					<HistoryItems
						history={data}
						hasMore={hasMore}
						isLoadingMore={loadingMore}
						onLoadMore={loadMore}
						sortOrder={sortOrder}
						GroupedActivityEntryComponent={GroupedActivityEntryComponent}
					/>
				);
			}}
		</IssueHistoryService>
	</FeedContainer>
);

IssueHistory.defaultProps = {
	HistoryItems: HistoryItemsDI,
	IssueHistoryService: IssueHistoryServiceDI,
};

export default IssueHistory;
